import { render, staticRenderFns } from "./payment_details.vue?vue&type=template&id=6b79e2ec&"
import script from "./payment_details.vue?vue&type=script&lang=js&"
export * from "./payment_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports